const commitSha = (
  import.meta.env.VITE_COMMIT_SHA as string | undefined
)?.slice(0, 7);

export function Footer({ className = "" }: { className?: string }) {
  return (
    <footer
      className={`py-4 text-center text-xs text-smoke ${className}`.trim()}
    >
      made with ❤️ by allezle.fun
      {commitSha && (
        <div className="mt-0.5 text-[10px] text-smoke/50">{commitSha}</div>
      )}
    </footer>
  );
}
